import axios from '@/components/api/axios';

async function getSalonList() {
  const res = await axios.axiosGet('/api/salon/reservation/getSalonList', {});
  return res;
}

async function getRoomList(salonId) {
  let payload = {
    salonId: salonId
  }
  const res = await axios.axiosGet('/api/salon/reservation/getRoomList', payload);
  return res;
}

async function getBusinessDayList(roomId) {
  let payload = {
    roomId: roomId
  }
  const res = await axios.axiosGet('/api/salon/reservation/getBusinessDayList', payload);
  return res;
}

async function getReservationHours(roomId) {
  let payload = {
    roomId: roomId
  }
  const res = await axios.axiosGet('/api/salon/reservation/getReservationHours', payload);
  return res;
}

async function getReservationTime(reservationDate, roomId) {
  let payload = {
    reservationDate: reservationDate,
    roomId: roomId
  }
  const res = await axios.axiosGet('/api/salon/reservation/getReservationTime', payload);
  return res;
}

async function getAvailabilityStatusTable(reservationDate, salonId) {
  let payload = {
    reservationDate: reservationDate,
    salonId: salonId
  }
  const res = await axios.axiosGet('/api/salon/reservation/getAvailabilityStatusTable', payload);
  return res;
}

async function getSeminarTypeList() {
  const res = await axios.axiosGet('/api/salon/reservation/getSeminarTypeList', {});
  return res;
}

async function reserve(payload) {
  const res = await axios.axiosPost('/api/salon/reservation/reserve', payload);
  return res;
}

async function getReservationList(pageNo=1) {
  let payload = {
    pageNo: pageNo,
  }
  const res = await axios.axiosGet('/api/salon/reservation/getReservationList', payload);
  return res;
}

async function cancelReservation(reservationId) {
  let payload = {
    reservationId: reservationId,
  }

  const res = await axios.axiosPost('/api/salon/reservation/cancel', payload);
  return res;
}

async function checkReservationTime(payload) {
  const res = await axios.axiosPost('/api/salon/reservation/checkReservationTime', payload);
  return res;
}


export default {
    getSalonList,
    getRoomList,
    getBusinessDayList,
    getReservationHours,
    getReservationTime,
    getAvailabilityStatusTable,
    getSeminarTypeList,
    reserve,
    getReservationList,
    cancelReservation,
    checkReservationTime
}



// WEBPACK FOOTER //
// ./src/components/api/salon/reservation.js